import styled, { css } from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Container from '../../Core/Container';
import Ctas from '../../Core/Ctas';

export const StyledContainer = styled(Container)`
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
  ${({ $backgroundColor }) =>
    $backgroundColor &&
    css`
      border: 1px solid ${themeGet(`colors.${$backgroundColor}`)};
    `}
  width: 100%;
  max-width: unset;
  margin: 0 auto;
  &.card-comparison {
    border-bottom: unset;
    border-left: unset;
    border-right: unset;
  }
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 0.75rem;
  gap: 0.5rem;

  h1,
  h2,
  h3,
  p {
    color: ${({ $textColor }) =>
      $textColor
        ? themeGet(`colors.${$textColor}`)
        : themeGet('colors.main-text')};
  }

  text-align: ${({ $textAlignment }) => $textAlignment || 'left'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 3rem 2.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 4rem 11.5rem;
  }

  ${StyledContainer}.card-comparison & {
    padding: 0 1.5rem 1rem;
    h2 {
      font-size: 20px;
    }
    p {
      font-size: 1rem;
      color: ${themeGet('colors.grey-text')};
    }
  }
`;

export const Heading = styled.h2`
  font-size: 2rem;
`;

export const Statement = styled.p`
  font-size: 1.125rem;
`;

export const StyledCtas = styled(Ctas)`
  margin: 0rem auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.center {
      margin: 1rem auto;
    }
  }
`;
